export const parsePhoneFormat = (phoneNumber: string) => {
    if (phoneNumber.includes('+')) {
        return phoneNumber
    }
    return '+' + phoneNumber
};  